import { useModalStore } from '@/store/apps/modalStore';

import Button from '../../buttons/Button';

type ButtonInfo = {
  submitButtonText?: string;
  closeButtonText?: string;
  modalSubmit?: () => void;
  modalClose?: () => void;
  buttonOptions?: { disabled: boolean };
};

type Props = {
  buttonsInfo: ButtonInfo[];
  /** Modal.Footer에 border-top이 있을 경우 true (Alert, Custom 제외하고 true) */
  children?: React.ReactNode;
};

export default function ModalFooter({ buttonsInfo }: Props) {
  const { modalFooterVariant } = useModalStore();

  return (
    <>
      {modalFooterVariant === 'primary' && (
        <ModalFooterPrimary buttonsInfo={buttonsInfo} />
      )}
      {modalFooterVariant === 'secondary' && (
        <ModalFooterSecondary buttonsInfo={buttonsInfo} />
      )}
    </>
  );
}

function ModalFooterPrimary({ buttonsInfo }: Props) {
  return (
    <div className="mt-auto flex w-full items-center justify-center gap-2 px-5 pb-5 pt-4 [&>button]:flex-1">
      {buttonsInfo.map((button: any, idx: number) => {
        if (button.closeButtonText) {
          return (
            <Button
              key={idx}
              className="w-full"
              variant="line"
              color="gray"
              size="md"
              onClick={button.modalClose}
              {...button.buttonOptions}
            >
              {button.closeButtonText}
            </Button>
          );
        }

        if (button.submitButtonText) {
          return (
            <Button
              key={idx}
              className="w-full"
              color="primary"
              size="md"
              onClick={button.modalSubmit}
              {...button.buttonOptions}
            >
              {button.submitButtonText}
            </Button>
          );
        }
      })}
    </div>
  );
}

function ModalFooterSecondary({ buttonsInfo }: Props) {
  return (
    <div className="mt-auto flex w-full items-center justify-center [&>button]:-ml-px [&>button]:flex-1">
      {buttonsInfo.map((button: any, idx: number) => {
        if (button.closeButtonText) {
          return (
            <Button
              key={idx}
              className="w-full h-[56px] border-apps-coreProductDivider rounded-none"
              variant="line"
              color="gray"
              size="md"
              onClick={button.modalClose}
              {...button.buttonOptions}
            >
              {button.closeButtonText}
            </Button>
          );
        }

        if (button.submitButtonText) {
          return (
            <Button
              key={idx}
              className="w-full h-[56px] text-apps-corePrimary01 border-apps-coreProductDivider rounded-none"
              variant="line"
              color="gray"
              size="md"
              onClick={button.modalSubmit}
              {...button.buttonOptions}
            >
              {button.submitButtonText}
            </Button>
          );
        }
      })}
    </div>
  );
}

